import { render } from "./RegistrarReportsDialog.vue?vue&type=template&id=e2e69b82&scoped=true"
import script from "./RegistrarReportsDialog.vue?vue&type=script&lang=js"
export * from "./RegistrarReportsDialog.vue?vue&type=script&lang=js"

import "./RegistrarReportsDialog.vue?vue&type=style&index=0&id=e2e69b82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e69b82"]])

export default __exports__